import * as React from 'react';
import { cn } from '../../lib/utils';
import { placeholderStyles } from './typography';

/**
 * Standardized Textarea Component
 * Consistent styling across admin and user flows
 * Supports light and dark themes
 */
export const Textarea = React.forwardRef(function Textarea({ className, ...props }, ref) {
  return (
    <textarea
      className={cn(
        'flex min-h-[80px] w-full rounded-md border border-gray-300 dark:border-gray-600',
        'bg-white dark:bg-gray-800',
        'px-3 py-2 text-sm font-normal font-sans',
        'text-gray-900 dark:text-gray-100',
        placeholderStyles,
        'ring-offset-background',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-colors',
        'resize-y',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;
